import {CargoItemMP} from '@logistics-frontend/types/schemas/delivery-corp-account-api/definitions'
import {PreOrderRetrieveResponse} from '@yandex-delivery/api/repo/dcaa'

import {Parcel, ParcelPaymentType, Product} from 'src/shared/types'

const toProduct = (cargoItemMP: CargoItemMP): Product => ({
  name: 'Автотовары', //cargoItemMP.title,
  count: cargoItemMP.quantity,
  price: cargoItemMP.cost_value,
  estimatedCost: 0,
  nds: 0,
  inn: '',
  width: String(cargoItemMP.size?.width ?? ''),
  height: String(cargoItemMP.size?.height ?? ''),
  length: String(cargoItemMP.size?.length ?? ''),
  weight: String(cargoItemMP.weight),
  marking: cargoItemMP.extra_id,
})

export const toParcels = (preOrderRetrieve: PreOrderRetrieveResponse, pointId: number): Parcel[] => {
  const items = preOrderRetrieve.claim.items ?? []

  return [
    {
      name: '',
      barcode: '',
      payment: ParcelPaymentType.Payed,
      size: 'custom',
      products: items.filter(item => item.droppof_point === pointId).map(toProduct),
    },
  ]
}
